// Sidebar is used by HomePage and MyToolsPage
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import * as Icons from '@fortawesome/free-solid-svg-icons';

// Add all icons to the library so you can use them dynamically
library.add(...Object.values(Icons).filter(icon => icon.prefix === 'fas'));

const Sidebar = ({ categories, selectedCategories, onCategoryChange, availabilityFilter, onAvailabilityChange }) => {
  const [hoveredCategory, setHoveredCategory] = useState(null);

  return (
    <aside className="bg-white shadow-md rounded-lg p-6 md:w-64 md:pr-4">
      <div className="mb-8">
        <h3 className="text-lg font-semibold mb-4 text-gray-700">Categories</h3>
        <div className="space-y-3">
          {categories.map(category => (
            <div 
              key={category.id} 
              className="flex items-center"
              onMouseEnter={() => setHoveredCategory(category.id)}
              onMouseLeave={() => setHoveredCategory(null)}
            >
              <label className="inline-flex items-center cursor-pointer relative">
                <div className="w-6 h-6 relative">
                  <input
                    type="checkbox"
                    checked={selectedCategories.includes(category.id)}
                    onChange={() => onCategoryChange(category.id)}
                    className={`form-checkbox h-5 w-5 absolute top-0 left-0 text-blue-600 transition duration-150 ease-in-out ${
                      hoveredCategory === category.id || selectedCategories.includes(category.id) ? 'opacity-100' : 'opacity-0'
                    }`}
                  />
                  <FontAwesomeIcon 
                    icon={Icons[category.icon]} 
                    className={`absolute top-0 left-0 h-5 w-5 text-gray-600 ${
                      (hoveredCategory === category.id || selectedCategories.includes(category.id)) ? 'opacity-0' : 'opacity-100'
                    }`} 
                  />
                </div>
                <span className="ml-2 text-gray-700">{category.name}</span>
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="text-sm text-gray-600 bg-stone-100 p-5 rounded-lg">
        <p className="mb-2 font-bold">Why a tool share?</p>
        <p className="mb-2">
          Sharing tools within a community reduces individual expenses, fosters cooperation, and creates social bonds among members.
        </p>
        <p className="mb-2">The next time you need a tool, check here first!</p>
      </div>
    </aside>
  );
};

export default Sidebar;
